import Vue from 'vue'
import Vuex from 'vuex'
import { 
    authModule,
    userModule,
    accountingModule,
    addressModule,
    shebaNumberModule,
    gatewayModule,
    ticketModule,
    storeModule,
    productModule,
    pardakhtShakhsiModule,
    notificationsModule,
    notificationModule,
    notificationSmsModule,
    verifyMailModule,
    cartModule,
    shaparakModule,
    pspRequestModule,
    dashboardModule,
    settlementModule,
    paymanModule,
    ivrModule,
    dedicatedModule,
    transactionModule,
    newsModule,
    collectiveModule,
    marketingModule,
    allotmentModule,
    blackListModule,
    badgeCounterModule,
    reportsModule,
    moneyRequestModule,
    knowledgeManagementModule,
    onlineFactorModule,
    bankingWageModule,
    transactionRoutingModule,
    posModule,
    customersClub,
    billModule,
    cardToCardModule,
    onlineContractModule
} from './modules'
import { abilityPlugin } from '@/common/ability'
import FAQModule from "./modules/FAQModule";
import WalletModule from "@/store/modules/walletModule";
import starshopDashboardModule from "@/store/modules/starshop/starshopDashboardModule";


Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [
        abilityPlugin
    ],
    modules: {
        auth: authModule,
        user: userModule,
        address: addressModule,
        shebaNumber: shebaNumberModule,
        gateway: gatewayModule,
        transactionRouting: transactionRoutingModule,
        ticket: ticketModule,
        store: storeModule,
        product: productModule,
        pardakhtShakhsi: pardakhtShakhsiModule,
        notifications: notificationsModule,
        notification: notificationModule,
        notificationSms:notificationSmsModule,
        verifyMail: verifyMailModule,
        cart:cartModule,
        shaparak: shaparakModule,
        pspRequest: pspRequestModule,
        dashboard: dashboardModule,
        starshopDashboard: starshopDashboardModule,
        settlement: settlementModule,
        payman: paymanModule,
        ivr: ivrModule,
        dedicated: dedicatedModule,
        transaction: transactionModule,
        news: newsModule,
        collective: collectiveModule,
        marketing: marketingModule,
        allotment: allotmentModule,
        blackList: blackListModule,
        badgeCounter: badgeCounterModule,
        reports: reportsModule,
        moneyRequest: moneyRequestModule,
        KnowledgeManagement: knowledgeManagementModule,
        onlineFactor: onlineFactorModule,
        bankingWage:bankingWageModule,
        customersClub: customersClub,
        pos:posModule,
        bill: billModule,
        FAQ: FAQModule,
        cardToCard: cardToCardModule,
        onlineContract: onlineContractModule,
        accounting: accountingModule,
        wallet: WalletModule
    },
})
